import defaultAvatar from '@/assets/img/default.png';

const PROFILE_STATUS = {
  PENDING: 0,
  APPROVED: 1,
  REJECTED: 2,
};

/**
 * 判断是否为掩码值（含 * 或与初始值相同且含掩码特征）
 */
export function isMaskedValue(value) {
  if (value === undefined || value === null || value === '') {
    return false;
  }
  return String(value).includes('*');
}

/**
 * 判断字段相对初始值是否未修改（含掩码回显视为未改）
 */
export function isFieldUnchanged(current, initial) {
  if (current === undefined || current === null || current === '') {
    return initial === undefined || initial === null || initial === '';
  }
  if (current === initial) {
    return true;
  }
  if (isMaskedValue(current) && (current === initial || isMaskedValue(initial))) {
    return true;
  }
  return false;
}

/**
 * 构建资料提交体：去掉未改的掩码字段；未改手机时不提交验证码
 */
export function buildProfileUpdatePayload(payload = {}, initial = {}) {
  let next = { ...payload };
  next = omitMaskedField(next, 'mobile', initial.mobile);
  next = omitMaskedField(next, 'email', initial.email);
  if (isFieldUnchanged(payload.mobile, initial.mobile)) {
    delete next.code;
  }
  return next;
}

/**
 * 若字段仍为掩码且未修改，则不提交
 */
export function omitMaskedField(payload, field, initialValue) {
  const current = payload[field];
  if (current === undefined) {
    return payload;
  }
  if (isMaskedValue(current) || (initialValue !== undefined && current === initialValue && isMaskedValue(initialValue))) {
    const next = { ...payload };
    delete next[field];
    return next;
  }
  return payload;
}

/**
 * 对外展示用户名
 */
export function getPublicUsername(user = {}, fallbackId = '') {
  if (user.profile_status === PROFILE_STATUS.APPROVED && user.public_username) {
    return user.public_username;
  }
  if (user.public_username) {
    return user.public_username;
  }
  const suffix = user.id || user.uid || (user.mobile ? String(user.mobile).slice(-4) : '') || fallbackId || 'xxxx';
  return `用户${suffix}`;
}

/**
 * 对外展示头像
 */
export function getPublicThumb(user = {}) {
  if (user.profile_status === PROFILE_STATUS.APPROVED && user.public_thumb) {
    return user.public_thumb;
  }
  if (user.public_thumb) {
    return user.public_thumb;
  }
  return defaultAvatar;
}

/**
 * 对外展示简介
 */
export function getPublicBio(user = {}) {
  if (user.profile_status === PROFILE_STATUS.APPROVED && user.public_bio) {
    return user.public_bio;
  }
  return user.public_bio || '';
}

/**
 * 个人中心审核状态文案
 */
export function getProfileStatusText(status) {
  switch (status) {
    case PROFILE_STATUS.PENDING:
      return '待审核';
    case PROFILE_STATUS.APPROVED:
      return '已通过';
    case PROFILE_STATUS.REJECTED:
      return '已驳回';
    default:
      return '';
  }
}

export { PROFILE_STATUS, defaultAvatar };
